import { render, staticRenderFns } from "./promo-projects.vue?vue&type=template&id=21d351ed"
import script from "./promo-projects.vue?vue&type=script&lang=js"
export * from "./promo-projects.vue?vue&type=script&lang=js"
import style0 from "./promo-projects.vue?vue&type=style&index=0&id=21d351ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports